export const getOdataTop = (search) => (search ? 20 : 100);
